export const DocumentType = Object.freeze({
  CurrentActivity: 'CurrentActivity',
  PrePaidInvoices: 'PrePaidInvoices',
  PrePaidStatement: 'PrePaidStatement',
  SelfServeInvoice: 'SelfServeInvoice',
  Invoice: 'Invoice',
  XandrInvoice: 'XandrInvoice',
  Pending: 'pending', // small case from MT, but i18n string still camelCase
  Invoices: 'Invoices',
  CreditMemoInvoice: 'CreditMemoInvoice',
  PostPaidStatement: 'PostPaidStatement',
  PrepaidCreditMemoInvoice: 'PrepaidCreditMemoInvoice',
  PrepaidChargebackInvoice: 'PrepaidChargebackInvoice',
  PrepaidRefundReversalInvoice: 'PrepaidRefundReversalInvoice',
  WriteOffCreditMemo: 'WriteOffCreditMemo',
  MonthlyStatement: 'MonthlyStatement',
  SalesHouseInvoice: 'SalesHouseInvoice',
  SalesHouseStatement: 'SalesHouseStatement',
});

export const DocumentTypeString = {
  [DocumentType.PrePaidInvoices]: _TL_('Payment receipt'),
  [DocumentType.PrePaidStatement]: _TL_('Monthly statement'),
  [DocumentType.SelfServeInvoice]: _TL_('Statement'),
  [DocumentType.Invoice]: _TL_('Invoice'),
  [DocumentType.XandrInvoice]: _TL_('Xandr invoice'),
  [DocumentType.Pending]: _TL_('Pending'),
  [DocumentType.Invoices]: _TL_('Invoice'),
  [DocumentType.CreditMemoInvoice]: _TL_('Credit memo'),
  [DocumentType.PostPaidStatement]: _TL_('Monthly statement'),
  [DocumentType.PrepaidCreditMemoInvoice]: _TL_('Credit memo'),
  [DocumentType.PrepaidChargebackInvoice]: _TL_('Credit memo'),
  [DocumentType.PrepaidRefundReversalInvoice]: _TL_('Debit memo'),
  [DocumentType.WriteOffCreditMemo]: _TL_('Credit memo'),
  [DocumentType.MonthlyStatement]: _TL_('Monthly statement'),
  [DocumentType.SalesHouseInvoice]: _TL_('Invoice (Sales House)'),
  [DocumentType.SalesHouseStatement]: _TL_('Monthly statement'),
};

export const CreditMemoDocumentType = [
  DocumentType.CreditMemoInvoice,
  DocumentType.PrepaidCreditMemoInvoice,
  DocumentType.PrepaidChargebackInvoice,
  DocumentType.WriteOffCreditMemo,
];

export const BillingDocumentRenderingMethod = Object.freeze({
  Account: 0,
  Billing: 1,
  Adjustment: 2,
});

export const IndiaEInvoicingStatus = Object.freeze({
  NotStarted: 0,
  Available: 1,
  Failed: 2,
  PendingSupport: 3,
  PendingIRNGeneration: 4,
  PendingCustomerAction: 5,
  PendingCreditAndRebill: 7,
});

export const ApContactType = Object.freeze({
  SAPLevel: 0,
  AccountLevel: 1,
});

export const APContactStatus = Object.freeze({
  PendingUserValidation: 0,
  Active: 1,
  Deleted: 2,
  Inactive: 3,
  PendingSystemValidation: 4,
  SystemValidationFailure: 5,
  Unknown: 6,
});

export const APContactMode = Object.freeze({
  Static: 'static',
  Edit: 'edit',
  Create: 'create',
});

export const IndiaDualInvoiceType = Object.freeze({
  Default: 0,
  RecipientCopy: 1,
  SupplierCopy: 2,
});

export const PaymodErrorCodes = Object.freeze({
  AuthorizationExpired: 'authorization_expired',
  ProcessorDeclined: 'processor_declined',
  ExpiredPaymentInstrument: 'expired_payment_instrument',
  ProcessorRiskcheckDeclined: 'processor_riskcheck_declined',
  AmountLimitExceeded: 'amount_limit_exceeded',
  InvalidPaymentInstrument: 'invalid_payment_instrument',
  InsufficientFund: 'insufficient_fund',
  MissingFundingSource: 'missing_funding_source',
  IncorrectPinOrPasscode: 'incorrect_pin_or_passcode',
  TransactionNotAllowed: 'transaction_not_allowed',
  MissingSessionData: 'missing_session_data',
  InvalidTransactionData: 'invalid_transaction_data',
  InvalidTransactionDataPrepay: 'invalid_transaction_data_12',
  InvalidTransactionDataThreshold: 'invalid_transaction_data_1',
  RiskReject: 'risk_evaluation_declined',
  AuthRequired: 'authentication_required',
  CVVValueMismatch: 'cvv_value_mismatch',
});

export const DefaultMinBillingThreshold = 50;

export const AccountBillMeNowStatus = Object.freeze({
  None: 0,
  ForceBill: 1,
  Refund: 2,
});

export const IndiaEMandateOfficialUrl = 'https://www.rbi.org.in/Scripts/BS_PressReleaseDisplay.aspx?prid=51353';

/**
 * Billing Document action
 */
export const BillingDocumentAction = Object.freeze({
  Credit: 0,
  Debit: 1,
  Rebill: 2,
});

export const CreditAndRebillType = {
  None: 0,
  ChangeNetAmount: 1,
  ChangeBillToCustomer: 2,
  ChangeBillToPI: 4,
  ChangePostPaidThresholdABL: 16,
  ChangePostPaidThresholdTaxId: 32,
  SkipCheckingConsolidatedBd: 64,
  AggregatorRebill: 128,
  AggregateeRebill: 256,
  ConsolidatorRebill: 512,
  ConsolidateeRebill: 1024,
  PIDeclinedRebill: 2048,
};

export const DocumentIdAttribute = 'DocumentId';
